const Index = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/RelatorioAuditoriaFornecedor/Index')
const Print = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/RelatorioAuditoriaFornecedor/Print')

export default [
  {
    path: 'relatorio-auditoria-fornecedor',
    name: 'RelatorioAuditoriaFornecedor',
    component: Index,
    meta: {
      title: 'Relatório Auditoria Fornecedor',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'relatorioAuditoriaFornecedor',
        action: 'read'
      }
    }
  },
  {
    path: 'relatorio-auditoria-fornecedor/:id/print',
    name: 'ImprimirRelatorioAuditoriaFornecedor',
    component: Print,
    meta: {
      title: 'Imprimir Relatório Auditoria Fornecedor',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'relatorioAuditoriaFornecedor',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/relatorio-auditoria-fornecedor.js